module.exports = __webpack_public_path__ + "media/ממתק.41691275.mp3";